/**
 * FeedbackLogicRuleAction
 */
export enum FeedbackLogicRuleAction {
    SHOW_QUESTIONS = 'show_questions',
    END_FEEDBACK = 'end_feedback'
}
